import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { SharedModule } from '../shared.moudle';

@Component({
  selector: 'app-file-preview',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './file-preview.component.html',
  styleUrl: './file-preview.component.scss'
})
export class FilePreviewComponent {

  @Input() file: { path: string; type: string; name: string } | null = null;
  @Input() index!: number;

  safeUrl: SafeResourceUrl | null = null;
  mimeType: string | null = null;
  textContent: string | null = null;
  name: string | null = null;
  isFullScreen = false;

  constructor(private sanitizer: DomSanitizer) {}

  loading = true;

  ngOnChanges(): void {
    if (!this.file || !this.file.path || !this.file.type) {
      this.safeUrl = null;
      this.mimeType = null;
      this.textContent = null;
      return;
    }

    this.mimeType = this.file.type.toLowerCase();
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.file.path);
    this.name = this.file.name;

    if (this.mimeType.startsWith('text')) {
      fetch(this.file.path)
        .then(res => res.text())
        .then(text => (this.textContent = text))
        .catch(() => (this.textContent = '[Unable to load content]'));
    } else {
      this.textContent = null;
    }
  }

  onMediaLoaded() {
    this.loading = false;
  }

  onViewClick(event: MouseEvent) {
    event.stopPropagation();
    this.isFullScreen = true;
  }

  closeFullScreen() {
    this.isFullScreen = false;
  }
}
